var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 73,
    viewBox: "0 0 94 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2266 72.7734H80.8047C89.0078 72.7734 93.0703 68.75 93.0703 60.7031V12.9688C93.0703 4.92188 89.0078 0.859375 80.8047 0.859375H13.2266C5.0625 0.859375 0.960938 4.92188 0.960938 12.9688V60.7031C0.960938 68.75 5.0625 72.7734 13.2266 72.7734ZM65.8438 36.7969C64.0859 35.2344 62.0547 34.375 59.9453 34.375C57.7969 34.375 55.8828 35.1172 54.0859 36.7188L36.4297 52.5L29.2031 45.9766C27.5625 44.4922 25.7656 43.75 23.9297 43.75C22.1719 43.75 20.5312 44.4531 18.8906 45.9375L7.25 56.4453V13.3203C7.25 9.25781 9.39844 7.14844 13.3047 7.14844H80.7266C84.5938 7.14844 86.7812 9.25781 86.7812 13.3203V56.4453L65.8438 36.7969ZM30.0625 37.1875C35.1016 37.1875 39.2422 33.0469 39.2422 27.9688C39.2422 22.9297 35.1016 18.75 30.0625 18.75C24.9844 18.75 20.8438 22.9297 20.8438 27.9688C20.8438 33.0469 24.9844 37.1875 30.0625 37.1875Z",
    fill: "#DFDFDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageIcon);
export default __webpack_public_path__ + "static/media/DefaultImageIcon.e30f282d.svg";
export { ForwardRef as ReactComponent };